import React, { useEffect, useState } from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

/**
 * Texto con un ícono pequeño a la derecha que lo copia al portapapeles.
 * `copyValue` permite copiar algo distinto de lo que se ve (por defecto, el
 * propio texto). Sin valor no se muestra el ícono.
 */
const CopyableText = ({ children, copyValue, label = 'texto', sx, iconSize = 14, ...typographyProps }) => {
  const [copied, setCopied] = useState(false);
  const value = copyValue ?? (typeof children === 'string' || typeof children === 'number' ? String(children) : '');

  useEffect(() => {
    if (!copied) {
      return undefined;
    }
    const timer = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timer);
  }, [copied]);

  const handleCopy = async (event) => {
    event.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch (error) {
      console.warn('No se pudo copiar al portapapeles:', error);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, minWidth: 0 }}>
      <Typography sx={{ minWidth: 0, overflowWrap: 'anywhere', ...sx }} {...typographyProps}>
        {children}
      </Typography>
      {value && (
        <Tooltip title={copied ? 'Copiado' : 'Copiar'}>
          <IconButton
            size="small"
            onClick={handleCopy}
            aria-label={`Copiar ${label}`}
            sx={{ p: 0.25, flexShrink: 0, color: copied ? 'var(--wb-success-strong)' : 'var(--wb-text-label)' }}
          >
            {copied ? <CheckIcon sx={{ fontSize: iconSize }} /> : <ContentCopyIcon sx={{ fontSize: iconSize }} />}
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default CopyableText;
